import React, { useState, KeyboardEvent } from "react";
import * as EmailValidator from "email-validator";
import { toLower } from "lodash";

interface DownloadWithEmailModalProps {
  closeModal: () => void;
  registerGuestUserAPI: string;
  eventId: number;
  setGuestUser: (userId: number, userEmail: string) => void;
}

const DownloadWithEmailModal: React.FC<DownloadWithEmailModalProps> = ({
  closeModal,
  registerGuestUserAPI,
  eventId,
  setGuestUser
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const registerGuestUser = async (email: string) => {
    if (!EmailValidator.validate(email)) {
      //@ts-ignore
      toastr.error("Please enter a valid email address");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(registerGuestUserAPI, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email,
          event_id: eventId
        })
      });

      if (!response.ok) {
        throw new Error("Failed to register");
      }

      const data = await response.json();

      setGuestUser(data.user_id, data.user_email);
    } catch (error) {
      console.error("Error:", error);
      //@ts-ignore
      toastr.error(
        "There was an error processing your request. Please try again."
      );
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      registerGuestUser(toLower(email));
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in confirm-modal-div geo-modal privacy-modal geo-multi-modal"
        role="dialog"
      >
        <div className="modal-dialog filter-dialog-content geo-privacy-body geo-privacy-modal">
          <div className="modal-content">
            <div className="modal-header">
              <span className="modal-title geo-privacy-title">
                Please enter your email address to download photo
              </span>
              <button
                type="button"
                className="close confirm-close"
                onClick={() => closeModal()}
              >
                <span>&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div>
                <input
                  type="email"
                  placeholder="Email address"
                  className="geo-round-input geo-form__pbg"
                  onKeyDown={handleKeyDown}
                  onChange={handleInputChange}
                  value={email}
                />
              </div>
              <div className="geo-modal__actions geo-collect-email-modal-footer ws-collect-email-footer">
                <button
                  className="geo-btn geo-btn--secondary geo-btn--caps"
                  onClick={e => registerGuestUser(toLower(email))}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Done"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default DownloadWithEmailModal;
